/*
*
* ©2018 EdgeVerve Systems Limited, Bangalore, India. All Rights Reserved.
*
* The EdgeVerve proprietary software program ("Program"), is protected by copyrights laws, international treaties
* and other pending or existing intellectual property rights in India, the United States and other countries. The Program
* may contain / reference third party or open source components, the rights to which continue to remain with the applicable
* third party licensors or the open source community as the case may be and nothing here transfers the rights to the third party
* and open source components, except as expressly permitted. Any unauthorized reproduction, storage, transmission in any
* form or by any means (including without limitation to electronic, mechanical, printing, photocopying, recording or 
* otherwise), or any distribution of this Program, or any portion of it, may result in severe civil and criminal penalties, and will be
* prosecuted to the maximum extent possible under the law.
* 
*/
import { Injectable } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import { Observable } from "rxjs";
import { environment } from "../../../environments/environment";

@Injectable()
export class ConfigService {

    private API_COMMON_BASE = `${environment.baseContext}/commapi`;
    private API_APP_CONFIG = "/appConfig";
    private API_GET_APP_SETTINGS = "/appSettings";
    private API_COMMON = "/common";
    private getMenuUrl = this.API_COMMON_BASE + this.API_COMMON + "/getMenus";


    constructor(private httpClient: HttpClient) { }

    getAppSettings(appCode) {
        let url = this.API_COMMON_BASE + this.API_APP_CONFIG + this.API_GET_APP_SETTINGS;
        let queryParams = new HttpParams().set('appCode', appCode);
        return this.httpClient.get(url, { params: queryParams });
    }

    getMenuItems(): Observable<any> {
        return this.httpClient.get(this.getMenuUrl);
    }
}

